import { styled } from '@mui/material';
import { CopyAll } from '@mui/icons-material';
import React, { FC, useCallback } from 'react';
import { useCopyToCliboard } from '../../hooks/useCopyToCliboard';

const FailedCopyContainer = styled('span')(({ theme }) => ({
  display: 'var(--copy-display)',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 2,
  color: theme.palette.text.secondary,
  position: 'absolute',
  padding: 4,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  cursor: 'pointer',
}));

const LazyFailedContainer = styled('span')(({ theme }) => ({
  backgroundSize: '50px',
  backgroundImage: 'linear-gradient(90deg, #ffffff20 0%, #ffffff2a 50%, #ffffff20 100%)',
  borderRadius: 4,
  color: theme.palette.text.disabled,
  padding: 4,
  fontSize: '12px',
  display: 'inline-block',
  width: '70px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  lineHeight: '1',
  position: 'relative',
  '--copy-display': 'none',
  '&:hover': {
    color: 'transparent',
    '--copy-display': 'inline-flex',
  },
}));

const StyledCopyAll = styled(CopyAll)({
  fontSize: '12px',
  lineHeight: '1',
});

const FailedCopy: FC<{ id: string }> = ({ id }) => {
  const copy = useCopyToCliboard();

  const onCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      copy(id, 'ID');
    },
    [id]
  );

  return (
    <FailedCopyContainer onClick={onCopy}>
      <StyledCopyAll />
      Copy ID
    </FailedCopyContainer>
  );
};

export const LazyFailed: FC<{ id: string }> = ({ id }) => {
  return (
    <LazyFailedContainer>
      {id}
      <FailedCopy id={id} />
    </LazyFailedContainer>
  );
};
